import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { CircularIndeterminate } from "components";
import modalStyles from "styles/pages/ModalActions.module.scss";
import huespedStyles from "./Huesped.module.scss";
import { Huesped, Reserva } from "assets/icons";

export default function DetallesHuesped({ huesped }) {
    const [loading, setLoading] = useState(false);

    const calcularDiasAtras = (fechaFormato) => {
        if (!fechaFormato) return "";
        // Recibe: "17/05/2026, 17:17"
        const parsed = moment(fechaFormato, "DD/MM/YYYY, HH:mm");
        if (!parsed.isValid()) return "";

        const dias = moment().diff(parsed, 'days');

        if (dias === 0) return "Hoy";
        if (dias === 1) return "hace 1 día";
        return `hace ${dias} días`;
    };


    const loadHuesped = useCallback(async () => {
        if (!huesped?.id) return;
        setLoading(true);
        // const result = await SFHotelUsuarioGet(credentials, {
        //     SFHabitacionId: habitacion.id,
        //     fecha,
        // });
        setLoading(false);
    }, [huesped?.id]);

    useEffect(() => {
        loadHuesped();
    }, [loadHuesped]);



    const formatFechaLocal = (value) => {
        if (value == null || value === "") return "";
        const str = String(value).trim();
        const [year, month, day] = str.split("-");
        if (year && month && day) {
            return `${day}/${month}/${year}`;
        }
        return str;
    };

    const renderInputs = [
        { "Número de habitación": huesped.habitacionNumero },
        { "Piso": huesped.habitacionPiso },
        { "Estado": huesped.reservaStatus },
        { "Noches": huesped.noches ? huesped.noches : '' },
        { "Fecha de inicio": formatFechaLocal(huesped.fechaDesde) },
        { "Fecha de fin": formatFechaLocal(huesped.fechaHasta) },
        { "Check-in": huesped.checkin ? huesped.checkin : '' },
        { "Check-out": huesped.checkout ? huesped.checkout : '' },
        { "Cancelación": huesped.cancelacion ? huesped.cancelacion : '' },
        { "Vouchers Utilizados": huesped.vouchersUtilizadosCantidad > 0 ? huesped.vouchersUtilizadosCantidad : '' },
        { "Número de Vouchers Utilizados": huesped.numeroVouchersUtilizados ? huesped.numeroVouchersUtilizados : '' }

    ]

    const inputs = renderInputs.reduce((acc, current) => {
        const key = Object.keys(current)[0];
        const value = current[key];

        if (value && value !== '' && value !== "0") {
            acc.push({ key, value });
        }

        return acc;
    }, []);

    return (
        <div className={modalStyles["detail-modal"]}>
            {
                loading ? (
                    <CircularIndeterminate />
                ) : (
                    <main style={{ overflowY: "auto", padding: "0", gap: "1.5rem", maxWidth: "100%" }}>
                        <div className={huespedStyles["huesped-details"]} >
                            <div style={{ flex: 1 }}>
                                <img src={huesped.imagen} alt="Foto del huésped" style={{ width: "200px", height: "200px", borderRadius: "8px", objectFit: "cover" }} />
                            </div>
                            <div className={huespedStyles["info-container"]} >

                                <h2> <img src={Huesped} alt="Ícono de huésped" width="20" height="20" /> DATOS PERSONALES</h2>

                                <div className={huespedStyles['datos']}>

                                    <div className={huespedStyles['datos-row']}>
                                        <span>Nombre y Apellido:</span>
                                        <strong>{huesped.usuarioNombres} {huesped.usuarioApellidos}</strong>
                                    </div>
                                    <div className={huespedStyles['datos-row']}>
                                        <span>Tipo de documento:</span>
                                        <strong>{huesped.tipoDeDocumentoCod}</strong>
                                    </div>
                                    <div className={huespedStyles['datos-row']}>
                                        <span>Documento:</span>
                                        <strong>{huesped.usuarioNroDeDocumento}</strong>
                                    </div>
                                    <div className={huespedStyles['datos-row']}>
                                        <span>Fecha de Nacimiento:</span>
                                        <strong>{huesped.usuarioFechaDeNacimiento}</strong>
                                    </div>
                                </div>
                            </div>
                            <div className={huespedStyles['ultimo-estado']} >
                                <h2>FECHA DE <br />RESERVA: </h2>
                                <span>
                                    {formatFechaLocal(huesped.reserva)}
                                </span>
                                <small>{calcularDiasAtras(huesped.reserva)}</small>
                            </div>
                        </div>

                        <div className={huespedStyles["reserva-details"]}>

                            <h2> <img src={Reserva} alt="Ícono de reserva" width="20" height="20" />DETALLES DE LA RESERVA</h2>

                            <div className={huespedStyles["reserva-info"]}>
                                {inputs.length <= 7 ? (
                                    <div style={{ display: "flex", flexDirection: "column", margin: "0 auto", gap: "0.5rem", flex: 1, flexWrap: "wrap", maxHeight: "180px" }}>

                                        {inputs.map((input, index) => {
                                            const key = input.key;
                                            const value = input.value;
                                            if (value === '' || value == null) return null;
                                            return (
                                                <div className={huespedStyles['datos-row']} key={index}>
                                                    <span>{key}:</span>
                                                    <strong>{value}</strong>
                                                </div>
                                            );
                                        })}

                                    </div>
                                ) : inputs.length === 8 ? (
                                    <div style={{ display: "flex", flexDirection: "column", margin: "0 auto", gap: "0.5rem", flex: 1, flexWrap: "wrap", maxHeight: "200px" }}>

                                        {inputs.map((input, index) => {
                                            const key = input.key;
                                            const value = input.value;
                                            if (value === '' || value == null) return null;
                                            return (
                                                <div className={huespedStyles['datos-row']} key={index}>
                                                    <span>{key}:</span>
                                                    <strong>{value}</strong>
                                                </div>
                                            );
                                        })}

                                    </div>
                                ) : (
                                <div style={{ display: "flex", flexDirection: "column", margin: "0 auto", gap: "0.5rem", flex: 1, flexWrap: "wrap", maxHeight: "220px" }}>

                                    {inputs.map((input, index) => {
                                        const key = input.key;
                                        const value = input.value;
                                        if (value === '' || value == null) return null;
                                        return (
                                            <div className={huespedStyles['datos-row']} key={index}>
                                                <span>{key}:</span>
                                                <strong>{value}</strong>
                                            </div>
                                        );
                                    })}

                                </div>
                                )
                                }

                            </div>
                        </div>
                    </main>
                )
            }
        </div>
    );
}
